export const MINI_CIP_BASE_ROUTE = '/cip';
export const MINI_CIS_BASE_ROUTE = '/cis';

export function isMiniOrbitBasePath(basePath: string) {

    if (basePath === MINI_CIP_BASE_ROUTE) {
        return true;
    }

    if (basePath === MINI_CIS_BASE_ROUTE) {
        return true;
    }

    return false;
}